import Service from "../Service";
const resource = "equipmentmaintenance/";

export default {

    pagination(obj, requestID) {
        return Service.post(resource + "paginationEquipment", obj, {
            params: { requestID: requestID },
        });
    },

};